<template>
  <div class="myCenterCommon__userContent__2fHEF route-fade-enter-done">
    <div class="style__titleHead__QII3Y common__clearfix__28XIR">
      <div class="title__title__RTC9P"><b>转账</b><span>场馆钱包和场馆钱包之间不可以互转</span></div>
      <ul class="tabs__tabsMyWallet__2l1uB">
        <li :class="$store.state.userInfo.transferstatus == 0 ? 'ddf tabs__active__qlOaY' : 'ddf '" @click="changeTasfer">转账模式</li>
        <li :class="$store.state.userInfo.transferstatus == 1 ? 'ddf tabs__active__qlOaY' : 'ddf '" @click="changeTasfer">免转模式</li>
      </ul>
    </div>
    <ul class="amountList__box__1_ZI4">
      <li style="width: 100%">
        <img src="https://www.8899851.com/oubo/static/image/sdqianbao.dc40ee4f3863c42e32b6a486b5b706fc.svg" class="amountList__icon__33WXt" />
        <div class="amountList__infoWrap__3hanq">
          <span>钱包</span>
          <div class="amountList__info__3_qtq">
            <span class="amountList__amount__3uzil left_than">{{ $store.state.userInfo.balance }}</span
            ><span class="amountList__rmb__2yHNG">元</span><img @click="getBalances" src="https://www.8899851.com/oubo/static/image/shuaxin.6eaac0e1956ef2120631f454674d245a.svg" class="amountList__refresh__3I1Qb" />
          </div>
        </div>
        <button @click="transall" class="index__Button__It0J4 index__Button3__1Pn-Q" style="width: 80px; height: 28px; position: absolute; right: 18px; top: 15px; border-radius: 20px; font-size: 14px">一键回收</button>
      </li>
    </ul>
    <ul class="style__walletlist__1AcAs common__clearfix__28XIR style__isShowMore__39BHt" style="margin-top: 20px">
      <li class="null null" v-for="(item, index) in balancelist" :key="index" @click="changVal(item)" v-if="item.platname != 'userbalance'">
        <div class="style__top__199Xy">
          <div>
            <span class="style__clientName__1Muqt">{{ item.name }}</span>
          </div>
          <div class="style__actionBtnBox__Hce64">额度转换</div>
        </div>
        <div class="style__money__1Iols">
          <i>{{ item.balance }}</i>
        </div>
      </li>
    </ul>

    <div class="el-dialog__wrapper" style="z-index: 999; background: rgb(81 73 73 / 49%)" @click="closeCv" v-if="openInfo.name">
      <div role="dialog" aria-modal="true" aria-label="额度转换" class="el-dialog" style="margin-top: 15vh" @click="retrun">
        <div class="el-dialog__header">
          <span class="el-dialog__title">额度转换</span><button type="button" @click="closeCv" aria-label="Close" class="el-dialog__headerbtn"><i class="el-dialog__close el-icon el-icon-close"></i></button>
        </div>
        <div class="el-dialog__body">
          <div class="el-form el-form--inline">
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item">
                <label class="el-form-item__label" style="width: 150px">平台账户余额</label>
                <div class="el-form-item__content">
                  <div class="el-input is-disabled"><input type="text" :value="$store.state.userInfo.balance" disabled="disabled" autocomplete="off" placeholder="平台账户余额" class="el-input__inner" /></div>
                  
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item">
                <label class="el-form-item__label" style="width: 150px">游戏账户余额</label>
                <div class="el-form-item__content">
                  <div class="el-input is-disabled"><input type="text" :value="openInfo.balance" disabled="disabled" autocomplete="off" placeholder="游戏账户余额" class="el-input__inner" /></div>
                  
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="bank_address" class="el-form-item__label" style="width: 150px">转账方式</label>
                <div class="el-form-item__content">
                   <el-radio v-model="payType" :label="0">转入</el-radio>
                    <el-radio v-model="payType" :label="1">转出</el-radio>
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -12px; margin-right: -12px">
              <div class="el-form-item is-required">
                <label for="money" class="el-form-item__label" style="width: 150px">操作金额</label>
                <div class="el-form-item__content">
                  <div class="el-input"><input type="text"  v-model="amount" autocomplete="off" placeholder="填写操作金额" class="el-input__inner" /></div>
                  
                </div>
              </div>
            </div>
            <div class="grid-content bg-purple el-row" style="margin-left: -10px; margin-right: -10px">
              <div class="el-col el-col-4" style="padding-left: 10px; padding-right: 10px"><div class="grid-content bg-purple"></div></div>
              <div class="el-col el-col-16" style="padding-left: 150px; padding-right: 10px">
                <button @click="isOk" type="button" class="el-button el-button--primary"><span>确认操作</span></button>
              </div>
              <div class="el-col el-col-4" style="padding-left: 10px; padding-right: 10px"><div class="grid-content bg-purple"></div></div>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'transfer',
  data() {
    return {
      nshow: true,
      balancelist: [],
      openInfo: {},
      amount: null,
      payType: 0,daoTime: null
    };
  },
  created() {
    let that = this;
    that.getbalancelist();
        that.daoTime = setInterval(() => {
      that.getbalancelistNoLoding();
    }, 1500);
  },
  methods: {
      retrun(event) {
      event.stopPropagation();
    },
    isOk() {
      let that = this;

      let sourcetype = '';
      let targettype = '';

      if (that.payType == 0) {
        //转入游戏
        sourcetype = 'userbalance';
        targettype = that.openInfo.platname;
      } else {
        //转入平台
        sourcetype = that.openInfo.platname;
        targettype = 'userbalance';
      }
      let info = { amount: that.amount, sourcetype: sourcetype, targettype: targettype };
      if (that.amount == null) {
        that.showTost(0, '请输入操作金额！');
        return;
      }

      that.showLoading();
      that.$apiFun.post('/api/transfer', info).then(res => {
        that.closeCv();
        that.showTost(1, res.message);

        if (res.code === 200) {
          that.refreshusermoney();
          that.getbalancelist();
        } else {
          that.hideLoading();
        }
      });
    },
    changVal(item) {
      let that = this;
      // $store.state.userInfo.transferstatus == 0  0  转账模式  1免转模式
      if (that.$store.state.userInfo.transferstatus == 1) {
        return;
      }
      that.openInfo = item;
      that.amount = null;
    },
    closeCv() {
      let that = this;
      that.openInfo = {};
      that.amount = null;
    },
    changeTasfer() {
      let that = this;
      that.showLoading();
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let mianzhuan = userInfo.transferstatus ? 0 : 1;

      that.$apiFun
        .post('/api/uptransferstatus', { transferstatus: mianzhuan })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            userInfo.transferstatus = mianzhuan;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
            that.showTost(1, '操作成功！');
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getBalances() {
      let that = this;
      that.showLoading();
      that.getbalancelist();

      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          that.hideLoading();
        })
        .catch(res => {
          // console.log(res)
          that.hideLoading();
        });
    },
        getbalancelistNoLoding() {
      let that = this;

      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.balancelist = res.data;
            let balancelist = res.data;
            balancelist.unshift({ platname: 'userbalance', name: '平台钱包' });
            that.balancelist = balancelist;
          }
        })
        .catch(res => {
        });
    },
    getbalancelist() {
      let that = this;
      that.showLoading();

      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.balancelist = res.data;
            let balancelist = res.data;
            balancelist.unshift({ platname: 'userbalance', name: '平台钱包' });
            that.balancelist = balancelist;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changBshow() {
      this.nshow = !this.nshow;
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    transall() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.showTost(1, res.message);
          that.getbalancelist();
          that.refreshusermoney();
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
    beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
};
</script>
<style lang="scss" scoped>
// @import '../../../static/css/announcement_modal.css';
@import '../../../static/css/Transfer_81ba8019.f1b60e17.css';
</style>



// WEBPACK FOOTER //
// src/components/mine/transfer.vue